/* This allows us to return errors from actions. Usually messages are blocked from reaching the front end
but many times, we desire to pass specific errors to the front end. This allows us to do so while still 
blocking error messages that we don't explicitly allow */

export type ServerActionResult<T> = { success: true; value: T } | { success: false; error: string };

export class ServerActionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ServerActionError';
  }
}

export function createServerAction<Return, Args extends unknown[] = []>(
  callback: (...args: Args) => Promise<Return>
): (...args: Args) => Promise<ServerActionResult<Return>> {
  return async (...args: Args) => {
    try {
      const value = await callback(...args);
      return { success: true, value };
    } catch (error) {
      if (error instanceof ServerActionError) {
        return { success: false, error: error.message };
      }
      throw error;
    }
  };
}
